import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  return (
    <div className="services services-coming-soon">
      {/* Return Home Button top-left */}
      <Link to="/" className="return-home-button">Return Home</Link>

      {/* Hero */}
      <section className="services-hero">
        <div className="container">
          <h1>Services</h1>
          <p>Coming soon</p>
        </div>
      </section>

      <section className="coming-soon-body">
        <div className="container">
          <h2>We are finalizing this page.</h2>
          <p>Please check back soon.</p>
        </div>
      </section>
    </div>
  );
};

export default Services;

